import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { getDashboardRentsSummaryExport } from '@api/dashboardPO';

import { TDashboardRentGeneralExportDTO } from '@interfaces/platform/dto/platformDashboardDTO';

import { ESnackbarTypes } from '@enums/common';

import { DASHBOARD_RENTS_SUMMARY_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export function useMutateDashboardAssetRentsExport() {
	const dispatch = useAppDispatch();

	const {
		mutate: exportDashboardRentsSummary,
		isLoading: isLoadingExportDashboardRentsSummary,
	} = useMutation<TDashboardRentGeneralExportDTO>({
		mutationKey: [DASHBOARD_RENTS_SUMMARY_EXPORT],
		mutationFn: getDashboardRentsSummaryExport,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportStartingSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return {
		exportDashboardRentsSummary,
		isLoadingExportDashboardRentsSummary,
	};
}
